import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCompare } from '../../../../mechanics/rid-compare/rid-compare';

@Component({
  selector: 'app-compare-page',
  imports: [RidCompare],
  templateUrl: './compare-page.component.html',
})
export class ComparePage {
  protected readonly $router = inject(Router);
}
